module.exports = __webpack_public_path__ + "static/media/06.15e4da12.png";